module.exports = __webpack_public_path__ + "static/media/one.aebf1da6.png";